<section class="mat-typography">
  <app-sidebar>
    <main class="app-content">
      <router-outlet></router-outlet>
    </main>
  </app-sidebar>
</section>
